// removed by extract-text-webpack-plugin
module.exports = {"box":"styles__box__KiBxv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Box/styles.scss
// module id = 884
// module chunks = 0